import { combineReducers } from 'redux';
import alertsReducer from './alerts/Reducer';

const Reducers = combineReducers({
  alertsReducer,
});

export default Reducers;
